import { get, IResponse, post } from "@Lib/request";
import { IComment, ICommentAddParams, ICommentData } from "@Types/articles";
import { ECommentType } from "@Types/constants";
import { IHotKinds } from "@Types/articles";
import { path, host } from "./url";
import axios from "axios";
import dayjs from "dayjs";
import getUUID from "@Lib/uuid";

const { usedCarApiV4, usedCarApiV3, newCarApiV2, newCarApiV3, newCarApiV1, newCarApiV5 } = path;

const { c } = host;

// 找車頁 - 筛选项
export async function fetchGetCarFilterData(params?: any) {
  return await get(`${path.newCarApiV3}/kinds/search/pc/condition`, params);
}

export async function fetchArticles() {
  return await get<any>(`${newCarApiV2}/pcArticle`);
}

export async function fetchV3Articles(params) {
  return await get<any>(`${newCarApiV3}/article`, params);
}

export async function fetchArticleNav(params?: any) {
  return await get<any>(`${newCarApiV3}/article/nav`, params);
}

export async function fetchArticleBanners(params?: any) {
  return await get<any>(`${newCarApiV3}/article/home/banners`, params);
}

export async function fetchNewsBanners(params?: any) {
  return await get<any>(`${newCarApiV3}/article/news/focus`, params);
}

export async function fetchRecommendHot(params?: any) {
  return await get<any>(`${newCarApiV3}/article/recommend/hot`, params);
}

export async function fetchRecommendColums(params?: any) {
  return await get<any>(`${newCarApiV3}/article/home/recommend/type`, params);
}

export async function fetchOilPrice(params?: any) {
  return await get<any>(`${newCarApiV3}/oil/price`, params);
}

export async function fetchNewlyListedCar(params?: any) {
  return await get<any>(`${newCarApiV3}/newlyListedCar`, params);
}

export async function fetchCharacter(params?: any) {
  return await get<any>(`${newCarApiV3}/article/home/character`, params);
}

export async function articleCategories(params: any) {
  return get<any>(`${newCarApiV3}/article/categories`, params);
}

export async function fetchMovies(params?: any) {
  return await get<any>(`${newCarApiV3}/article/home/movies`, params);
}

export async function fetchNewCarBrands(params?: any) {
  return await get<any>(`${newCarApiV2}/brand/select`, {
    type: "base",
    ...params,
  });
}

export async function fetchNewCarKinds(params?: { b: number; type: string }) {
  return await get<any>(`${newCarApiV2}/kind/select`, {
    type: "base",
    ...params,
  });
}

export async function fetchModel(params?: any) {
  return await get<any>(`${newCarApiV2}/model/select`, {
    type: "base",
    ...params,
  });
}

export async function fetchHotsell(params?: any) {
  return await get<any>(`${newCarApiV3}/kinds/newest/hotsell`, {
    type: "base",
    ...params,
  });
}

export async function collect(id, type, position) {
  return await get<any>(`${newCarApiV3}/collect`, { id, type, position });
}

export async function articleCategory(params: { id: string }) {
  return await get<any>(`${newCarApiV3}/article/category`, params);
}

export async function newArticleCategory(params: { id: string }) {
  return await get<any>(`${newCarApiV5}/article/category/info`, params);
}

export async function fetchCategoryBanners(params?: any) {
  return await get<any>(`${newCarApiV3}/article/category/home/banner`, params);
}

export async function fetchPaging(url) {
  return await get<any>(url);
}

export async function fetchHotArticle(params) {
  return await get<any>(`${newCarApiV3}/recommendation/articles`, params);
}

export async function fetchCategoryNav(params?: any) {
  return await get<any>(`${newCarApiV3}/article/category/nav`, params);
}

export async function fetchAfterSale(params?: any) {
  return await get<any>(`${newCarApiV3}/article/afterSale/focus`, params);
}

export async function fetchArticlePolymer(params?: any) {
  return await get<any>(`${newCarApiV3}/article/polymer`, params);
}

export async function fetchSuperTestShock(params?: any) {
  return await get<any>(`${newCarApiV3}/superTest/shock`, params);
}

export async function fetchLike(params?: any) {
  return await get<any>(`${newCarApiV3}/like`, params);
}

export async function fetchComment(params?: any) {
  return await post<any>(`${newCarApiV3}/campaigns/comment`, params);
}

export async function fetchSuperTestRank(params?: any) {
  return await get<any>(`${newCarApiV3}/superTest/ranking`, params);
}

export async function fetchArticleContent(params?: any) {
  return await get<any>(`${newCarApiV3}/article/content`, params);
}

// 精選推薦
export async function fetchRecommendArticleChoice(params?: any) {
  return await get<any>(`${newCarApiV3}/article/recommend/choice`, params);
}

// 關聯文章列表
export async function fetchRecommendArticleRelated(params?: any) {
  return await get<any>(`${newCarApiV3}/article/recommend/related`, params);
}

/** 新增评论 */
export async function fetchCommentAdd(params: ICommentAddParams): Promise<IResponse<ICommentData>> {
  return post<ICommentData>(`${newCarApiV3}/comment/add`, params);
}
/** 评论列表 */
export async function fetchCommentList(params: {
  id: string;
  limit?: number;
  type: ECommentType;
}): Promise<IResponse<{ list: IComment[]; total: number }>> {
  return get<{ list: IComment[]; total: number }>(`${newCarApiV3}/comment/list`, params);
}

export async function fetchCommentLike(params: {
  id: string;
  type: ECommentType;
  otherId?: string;
}): Promise<IResponse<{ content: string }>> {
  return get<{ content: string }>(`${newCarApiV3}/comment/like`, params);
}

export async function fetchWellChosen(params?: any) {
  return await get<any>(`${newCarApiV3}/featured/categories`, params);
}

/** 合輯相關車款 */
export async function fetchArticleCar(params?: any) {
  return await get<any>(`${newCarApiV3}/article/category/kinds`, params);
}

export async function fetchConcernedkind(params: any) {
  return await get<any>(`${c}/summary/concernedkind`, params);
}

/**
 * 自建广告批量统计
 */
export function postBatchCollect(data: any[], actionType?: string, site?: string) {
  const res = axios
    .post(
      "https://dc.8891.tw/api/genericBulk",
      JSON.stringify({
        es_tag: "t_advertising",
        common: {
          action: {
            type: actionType,
            platform: "pc",
            time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            site: site,
          },
          device: {
            userAgent: window.navigator.userAgent,
            deviceId: getUUID(),
          },
        },
        bulk: data,
      }),
      {
        withCredentials: true,
      },
    )
    .then(function (res) {});
}

export async function fetchHotSellKind(params: any) {
  return await get<any>(`${c}/main/hotsell`, params);
}

export async function fetchSummaryCompetkind(params) {
  return await get(`${path.newCarApiV3}/kinds/complete/list`, params);
}

/** 影音配置內頁info */
export async function fetchEquipsInfo(params) {
  return await get(`${path.newCarApiV4}/equip/movie/info`, params);
}

/** 影音配置点赞点踩 */
export async function fetchLikeOrUnLike(params) {
  return await get(`${path.newCarApiV3}/like`, params);
}

/** 影音配置点赞点踩-状态 */
export async function fetchEquipMovieLikeStatus(params) {
  return await get(`${path.newCarApiV3}/like/status`, params);
}
/** 批量点赞 */
export async function fetchLikeStatusBulk(params: any): Promise<IResponse<any>> {
  return await get(`${path.newCarApiV3}/like/status/bulk`, params);
}

/** 影音配置点赞点踩-状态 */
export async function fetchEquipMovieCategoriesList(params) {
  return await get(`${path.newCarApiV3}/movie/categories/list`, params);
}

/** 影音配置 - 影音配備詳解 */
export async function fetchEquipMovieCategoriesInfo(params) {
  return await get(`${path.newCarApiV4}/equip/movie/list`, params);
}

/** 综述页 - 影音配備詳解 */
export async function fetchSummaryEquipMovie(params) {
  return await get(`${path.newCarApiV4}/equip/movies/info`, params);
}

/** 影音配備詳解 - nav */
export async function fetchEquipMovieNav(params) {
  return await get(`${path.newCarApiV4}/equip/movies/nav`, params);
}

/** 影音配備詳解 - 多组影音 */
export async function fetchEquipMovie(params) {
  return await get(`${path.newCarApiV4}/equip/movies`, params);
}

/** 文章标签页 - 相关车款 */
export async function fetchTagKindss(params) {
  return await get(`${path.newCarApiV3}/tag/kinds`, params);
}

/** 车款专题 - 列表 */
export async function fetchKindTopic(params: any) {
  return await get(`${path.newCarApiV3}/kinds/categories`, params);
}

/** 车款专题 - 详情 */
export async function fetchKindTopicDetail(params: any) {
  return await get(`${path.newCarApiV3}/kinds/category`, params);
}

/** 銷售線索 - 熱門車款 */
export async function fetchHotKinds(params: { limit?: number }): Promise<IResponse<{ list: IHotKinds[] }>> {
  return await get(`${path.newCarApiV3}/saleLeads/hotKinds`, params);
}

/** 综述页 - 买车影音、买车资讯 - nav */
export async function fetchArticleAnyMoviesNav(params: any) {
  return await get(`${path.newCarApiV4}/kinds/pc/information/columns`, params);
}

/** 综述页 - 車型列表 */
export async function fetchKindsModels(params: any) {
  return await get(`${path.newCarApiV5}/kinds/models`, params);
}

/** 综述页 - 停售車型年份 */
export async function fetchStopSalesYears(params: any) {
  return await get(`${c}/summary/oldkind`, params);
}

/** 综述页 - 停售車型年份 */
export async function fetchSumTestingRanking(params: any) {
  return await get(`${path.newCarApiV5}/kinds/super-test-rank`, params);
}

/** 综述页 - 熱門車型對比 */
export async function fetchHotKindsPk(params: any) {
  return await get(`${path.newCarApiV3}/compared/recommend`, params);
}

/** 综述页 - 競爭車款 */
export async function fetchSumKindsCompete(params: any) {
  return await get(`${path.newCarApiV4}/kinds/compete`, params);
}

/** 文章页 - 相关車款 */
export async function fetchArticleRelatedKinds(params: any) {
  return await get(`${path.newCarApiV4}/article/relation/kinds`, params);
}

/** 文章页 - 文章評論列表頁 */
export async function fatchArticleGetComment(params: any) {
  return await get(`${path.newCarApiV1}/mobile/article/getComment`, params);
}

/** 文章页 - 文章評論列表頁点赞 */
export async function fatchApiV2(params: any) {
  const { apiUrl, ...param } = params;
  return await get(`${path.newCarApiV2}${apiUrl}`, param);
}

/** 文章页 - 评论点赞 */
export async function mobileArticleAddComment(params: any) {
  return await post(`${path.newCarApiV1}/mobile/article/addComment`, params);
}

/*** 評論二級頁 ***/
// 文章信息業
export async function fatchArticleDetails(params) {
  return await get(`${path.newCarApiV2}/article/details`, params);
}

// 七天热门文章
export async function fatchArticleSevenDaysHot(params) {
  return await get(`${path.newCarApiV2}/article/sevenDaysHot`, params);
}
/** 综述页 - 车型列表(无分组)  */
export async function fetchAllKindsModels(params: any) {
  return await get(`${path.newCarApiV5}/kinds/model/list`, params);
}

/** 文章页 - 车型列表(有分组)  */
export async function fetchKindsModelsCompare(params: any) {
  return await get(`${path.newCarApiV4}/compare/max-model-list`, params);
}